export default __webpack_public_path__ + "static/media/nat_s.e270ef4c.jpg";